module.exports = __webpack_public_path__ + "ne.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/ne.svg
// module id = 725
// module chunks = 0